export const ERROR = 'Ocurrió un error.';
export const SUCCESS = 'Acción realizada con éxito.';

export const SINPLANACTIVO = 'Sin plan activo';
export const DIASPRUEBA = '15 días gratis'